
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 350 350"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M315.47 72.547V56.359c0-13.099-10.657-23.756-23.756-23.756H265.47c-13.099 0-23.756 10.657-23.756 23.756v15.427H198.53v-12.5c0-17.134-13.939-31.073-31.073-31.073H65.604c-17.134 0-31.073 13.939-31.073 31.073v13.26C14.894 76.289 0 93.577 0 114.286v165c0 23.435 19.065 42.5 42.5 42.5h265c23.435 0 42.5-19.065 42.5-42.5v-165c0-20.709-14.894-37.997-34.53-41.739zm-53.756-16.188a3.76 3.76 0 013.756-3.756h26.244a3.76 3.76 0 013.756 3.756v15.427h-33.756V56.359zM54.531 59.286c-.001-6.105 4.967-11.073 11.073-11.073h101.854c6.105 0 11.073 4.967 11.073 11.073v12.5h-124v-12.5zm275.469 220c0 12.407-10.094 22.5-22.5 22.5h-265c-12.406 0-22.5-10.093-22.5-22.5v-165c0-12.407 10.094-22.5 22.5-22.5h265c12.406 0 22.5 10.093 22.5 22.5v165z"}}),_c('path',{attrs:{"d":"M125 116.786c-44.112 0-80 35.888-80 80s35.888 80 80 80 80-35.888 80-80-35.888-80-80-80zm0 140c-33.084 0-60-26.916-60-60s26.916-60 60-60 60 26.916 60 60-26.916 60-60 60zM293.728 109.286h-29.333c-11.212 0-20.334 9.122-20.334 20.333v19.333c0 11.212 9.122 20.333 20.334 20.333h29.333c11.212 0 20.333-9.122 20.333-20.333V129.62c0-11.212-9.122-20.334-20.333-20.334zm.333 39.667a.333.333 0 01-.333.333h-29.333a.333.333 0 01-.334-.333V129.62c0-.184.149-.333.334-.333h29.333c.184 0 .333.149.333.333v19.333z"}})])
          )
        }
      }
    